import React from 'react';
import { Modal } from '@mui/material';
import Receitas from '../../Receitas/Receitas';


const ModalReceitas = React.forwardRef((props, ref) => {
  return (
    <Modal
      open={props.dateToOpen}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
        <>
        <div style={{height: 100}} />
        <Receitas dateToOpen={props.dateToOpen}/>
        </>
        
      
    </Modal>
  );
});

/*
AddProposta.propTypes = {
  produto: PropTypes.object,
  onConfirm: PropTypes.func,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  onClose: PropTypes.func,
}
*/

export default ModalReceitas;
